import { authorizedUpload, authorizedFetch as fetch, fetchPOST } from '@/helpers/authFetch';
import { documentationEndPoint, checkFileOk, checkServiceOK } from './serviceConstants';

const getCampaignDocuments = (id) => (
  fetch(`${documentationEndPoint}/documents/campaign-request/${id}`).then(checkServiceOK)
);

const getConfiguration = () => (
  fetch(`${documentationEndPoint}/documents/configuration`).then(checkServiceOK)
);

const getDownload = (id) => (
  fetch(`${documentationEndPoint}/documents/download?id=${encodeURIComponent(id)}`).then(checkFileOk)
);

const uploadAttachment = async (files, CR, onUploadProgress, tag, jointVenture) => {
  const url = `${documentationEndPoint}/documents/campaign-request/${CR}/attachments${tag &&`?tag=${encodeURIComponent(tag)}&jointVenture=${jointVenture}`}`;

  return authorizedUpload(url, files, onUploadProgress);
};

const uploadSubCampaignAttachment = async (files, CR, onUploadProgress, tag, jointVenture) => {
  const url = `${documentationEndPoint}/documents/campaign-request/${CR}/sub_campaign_attachments?tag=${encodeURIComponent(tag)}&jointVenture=${jointVenture}`;

  return authorizedUpload(url, files, onUploadProgress);
};

const uploadAttachmentPlant = (file, CR, tab, name, wkzNumber, onUploadProgress) => {
  const url = `${documentationEndPoint}/documents/campaign-request/${CR}/${tab}/${encodeURIComponent(name)}?wkzPlant=${wkzNumber}`;

  return authorizedUpload(url, file, onUploadProgress);
};

const pdf = (CR, language) => (
  fetch(`${documentationEndPoint}/pdfs/${CR}/generate-on-the-fly/${language}`).then(checkFileOk)
);

const pdfSubCR = (subCampaignId, language) => (
  fetch(`${documentationEndPoint}/pdfs/${subCampaignId}/generate-for-subcr/${language}`).then(checkFileOk)
);

export default {
  getCampaignDocuments,
  getDownload,
  uploadAttachment,
  uploadSubCampaignAttachment,
  uploadAttachmentPlant,
  pdf,
  pdfSubCR,
  getConfiguration,
};
